import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export default function StatCard({ label, value, sub, icon: Icon, tone = "default", testId, onClick }) {
  const toneMap = {
    default: "text-foreground",
    success: "text-emerald-700",
    warning: "text-amber-700",
    error: "text-red-700",
    info: "text-blue-700",
  };
  const interactive = typeof onClick === "function";
  return (
    <Card
      className={cn(
        "rounded-lg border-border shadow-none",
        interactive && "cursor-pointer hover:bg-muted/40 hover:border-foreground/30 transition-colors"
      )}
      data-testid={testId}
      onClick={onClick}
      role={interactive ? "button" : undefined}
      tabIndex={interactive ? 0 : undefined}
      onKeyDown={interactive ? (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick(); } } : undefined}
    >
      <CardContent className="p-6">
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="tiny-label">{label}</div>
            <div className={cn("mt-2 font-display text-3xl font-bold tracking-tight", toneMap[tone])}>
              {value}
            </div>
            {sub && <div className="mt-1 text-sm text-muted-foreground">{sub}</div>}
          </div>
          {Icon && (
            <div className="w-10 h-10 rounded-md bg-muted grid place-items-center text-muted-foreground">
              <Icon className="w-5 h-5" strokeWidth={1.5} />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
